import { render, staticRenderFns } from "./RentObjectPrices.vue?vue&type=template&id=6c2da2ed&lang=pug"
import script from "./RentObjectPrices.vue?vue&type=script&lang=js"
export * from "./RentObjectPrices.vue?vue&type=script&lang=js"
import style0 from "./RentObjectPrices.vue?vue&type=style&index=0&id=6c2da2ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports